import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ac-type-null-icon',
  templateUrl: './ac-type-null-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AcTypeNullIconComponent {}
